/**
 * MasterFormulaBuilder — composes subformula references into the group score.
 *
 * Collapsed by default to keep the focus on subformulas (which are built
 * first). The header always shows a one-line preview of the current
 * expression so users can see the result without expanding.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, useState } from 'react';
import type { FormulaBlockNode, FormulaSubformula } from '@trafficpulse/shared';

import { BlocksBuilder } from '../blocks';

import MasterFormulaHeader from './MasterFormulaHeader';

export interface MasterFormulaBuilderProps {
  master: FormulaBlockNode | null;
  masterExpression: string;
  subformulas: FormulaSubformula[];
  onMasterChange: (next: FormulaBlockNode | null) => void;
}

const MasterFormulaBuilder: FC<MasterFormulaBuilderProps> = ({
  master,
  masterExpression,
  subformulas,
  onMasterChange,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-2 rounded-md border border-primary/30 bg-primary/5 p-3">
      <MasterFormulaHeader
        open={open}
        onToggle={() => setOpen((v) => !v)}
        masterExpression={masterExpression}
        subformulas={subformulas}
      />
      {open ? (
        <div className="border-t border-primary/20 pt-2">
          <BlocksBuilder
            ast={master}
            onChange={onMasterChange}
            subformulas={subformulas}
          />
        </div>
      ) : null}
    </div>
  );
};

export default MasterFormulaBuilder;
